import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppConfigProvider } from './context/AppContextProvider';
import { ModalProvider } from './features/modal/ModalProvider';
import { UserContextProvider } from './context/UserContextProvider';
import { DataProvider } from './context/DataContextProvider';
import { CampusContextProvider } from './context/CampusContextProvider';

import store from './store';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <AppConfigProvider>
        <UserContextProvider>
          <CampusContextProvider>
            <DataProvider>
              <ModalProvider>
                <App />
              </ModalProvider>
            </DataProvider>
          </CampusContextProvider>
        </UserContextProvider>
      </AppConfigProvider>
    </QueryClientProvider>
  </Provider>
);
